import { createFileRoute } from '@tanstack/react-router';

import { ComingSoon } from '@/components/common/ComingSoon';
import * as m from '@/paraglide/messages.js';

export const Route = createFileRoute('/{-$locale}/events/')({
  component: EventsPage,
});

function EventsPage() {
  return <ComingSoon title={m.page_events()} />;
}
